export const actionsColumnId = 'actions';
export const selectionColumnId = 'select-col';
export const fakeColumnId = 'fake-column';

export const internalTableColumnIds = [actionsColumnId, selectionColumnId, fakeColumnId] as const;

export function isInternalTableColumnId(columnId: string) {
  return internalTableColumnIds.includes(columnId as (typeof internalTableColumnIds)[number]);
}
